import React from "react";
import { Layout, Row } from "antd";
import "./welcome.css";
import WelcomeLeft from "../welcome-left/WelcomeLeft";
import WelcomeRight from "../welcome-right/WelcomeRight";

const Welcome = ({ user, logout, login }) => {
  return (
    <Layout className="layout">
      <Row className="row">
        <WelcomeLeft />
        <WelcomeRight user={user} login={login} logout={logout} />
      </Row>
    </Layout>
  );
};

export default Welcome;
